/**
 * A titled, collapsible section used to separate the single-investor scorecard
 * from the all-investors table on the match panel. Open by default; the header
 * toggles visibility of the body.
 */
import { ReactNode, useState } from 'react';
import { Icon } from 'semantic-ui-react';

interface Props {
  title: string;
  defaultOpen?: boolean;
  children: ReactNode;
}

export default function CollapsibleSection({
  title,
  defaultOpen = true,
  children,
}: Props) {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div className="buyer-profile-match__section">
      <button
        type="button"
        className="buyer-profile-match__section-header"
        onClick={() => setOpen((o) => !o)}
      >
        <Icon name={open ? 'dropdown' : 'caret right'} />
        {title}
      </button>
      {open ? (
        <div className="buyer-profile-match__section-body">{children}</div>
      ) : null}
    </div>
  );
}
